/*
 Formularz
 wykorzystano bibliotekę Formik
 
 historia:
  2019-04-19 (JW): pierwsza wersja na podstawie formularza Smarty
*/
// https://bit.dev/mui-org/material-ui/dialog-content
// https://material-ui.com/api/dialog/
// https://material-ui.com/demos/buttons/
//
import React from 'react';

import { connect, Provider } from 'react-redux';

import { Actions, AppState, DaneNIP, PanelState, store, Values, ZapisanyFormularz, IPageState }
    from '../../appredux';

import UserInfo from './UserInfo';
import Notifier, { Content } from '../Notifier';
import { bookService, payService, Rezerwacja, ReservationId, obiektService, vscPaymentPrzelewy24, payServicePrzelewy24, RezerwacjaPobyt, Info, PokojOpcja, nipService, RodzPokoiInfo, dostepnoscPokoju, Dostepnosc } from '../../api';
import { days, formatDate, normalizeText, capitalizeAll,  wciecie, zbudujLiczbeLosowa, sendErrorLog, datediff, phoneSplit, selectTheme, capitalizeFirstLetter } from '../common/helpers';
import CONFIG from '../../cfg/config';
import ReactDOM from 'react-dom';
import { withStyles, Theme, MuiThemeProvider, WithStyles } from '@material-ui/core/styles';

import theme, { ThemeOrange } from '../../themes/themes';

import { FieldTypes, FormFields } from '../common/formFields/renderFields';
import { FormularzLabels } from './formularzStale';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { mobileBreakpoint, PoleDlugosciDwaWWierszu, PoleDlugosciJednoWWierszu } from '../common/formFields/formularzStaleWspolne';
import { TFunction } from 'i18next';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from "@material-ui/core/DialogContentText";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Paper } from '@material-ui/core';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { setLocale } from '../common/localeHelpers';
import {  Box, Link, Grid } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';
import { renderFields } from '../common/formFields/renderFields';
import UserPrefs from './UserPrefs';
import moment from 'moment';

import TodayIcon from '@mui/icons-material/Today';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import BedroomParentIcon from '@mui/icons-material/BedroomParent';
import BedroomParentOutlinedIcon from '@mui/icons-material/BedroomParentOutlined';
import KingBedIcon from '@mui/icons-material/KingBed';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PinIcon from '@mui/icons-material/Pin';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import CheckIcon from '@mui/icons-material/Check';
import SmsIcon from '@mui/icons-material/Sms';

import {InputAdornment, IconButton } from '@material-ui/core';
import EventIcon from '@mui/icons-material/Event';

import FormularzFaktura from './FormularzFaktura';
import DialogNoPayment from './DialogNoPayment';

//GoogleAnalytics
import ReactGA from 'react-ga';
import Ceny from './Ceny';



//PM 2021-11-16
//wstrzykniecie tylko uzywanych pol z magazynu danych
type FormularzProps = {
    page: IPageState,
    czyPobytZmieniany: boolean,
    zmienianyPobyt: RezerwacjaPobyt,
    dateFromFormularz: string,
    dateTo: string,
    basket: RodzPokoiInfo[],
    openOptions: number,
    lang: string,
    roomNumber: number,
    optionsValues: string[],
    contact: Info,
    theme: string,
    zapisanyFormularz: ZapisanyFormularz,
    preautoryzacja: number,
    initialValues: Values,
    options: PokojOpcja[],
    daneNIP: DaneNIP,
}

type FormularzState = {
    open: boolean,
    openInfo: boolean,
    infoValues: Content[],
    reservation: Rezerwacja,
    fromDate: string,
    toDate: string,
    fromDatePrev: string,
    toDatePrev: string,
    fromDateError: string,
    toDateError: string,
    openError: boolean,
    persons: number,
    rooms: number,
    freeRooms: number,
    width: number,
    dostepnosc: dostepnoscPokoju[],

    leftPanel: number,
    remarks: string,
    checked: string[],
    part: number,
}

const dajIloscOsob = (id: string): number => {
    let rooms = store.getState().pageState.rooms;
    const index = rooms.findIndex(item => item.id === id);
    if (index < 0) return 0;
    else return Number(rooms[index].iloscMiejsc);
}

class FormularzImplementacja extends React.Component<WithTranslation & FormularzProps & TransProps & WithStyles<typeof styles>, FormularzState> {
    _ismounted: boolean;

    disabledAll: boolean;

    //PM 2021-11-16
    //wstrzyknieie tylko uzywanych pol z magazynu danych
    //persons, fromDate, toDate, fromDatePrev, toDatePrev, fromDateError, toDateError
    constructor(props: WithTranslation & FormularzProps & TransProps & WithStyles<typeof styles>) {
        super(props, {});
        const zapisanyFormularz = this.props.zapisanyFormularz.pokoj !== ''
        const fromDate = this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.pobyt_od : zapisanyFormularz ? this.props.zapisanyFormularz.dataOd : this.props.dateFromFormularz
        const toDate = this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.pobyt_do : zapisanyFormularz ? this.props.zapisanyFormularz.dataDo : this.props.dateTo
        //vscTest
        //console.log(this.props.page.dateTo)
        this._ismounted = false
        this.state = {
            open: true,
            openInfo: false,
            infoValues: [],
            reservation: new Rezerwacja(),
            fromDate: fromDate,
            toDate: toDate,
            fromDatePrev: fromDate,
            toDatePrev: toDate,
            fromDateError: fromDate,
            toDateError: toDate,
            openError: false,
            persons: Number(
                this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.ilosc_osob : zapisanyFormularz ? this.props.zapisanyFormularz.osob : this.props.basket[0].iloscMiejsc
            ),
            rooms: this.props.czyPobytZmieniany? 1 : 1, //this.props.zapisanyFormularz.osob
            freeRooms: 1, //this.props.zapisanyFormularz.osob
            width: window.innerWidth,
            dostepnosc: [], 

            remarks: this.props.czyPobytZmieniany ? this.props.initialValues.remarks : "",
            checked: [],
            leftPanel: 0,
            part: 0
        }
        this.disabledAll = CONFIG.menu1PobytZmien === "2" && props.czyPobytZmieniany
        this.checkedValues()
        sendErrorLog("1", "1", "formularz")
        ReactGA.event({
            category: 'Nawigacja',
            action: 'Formularz'
        });
          
    }

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    async componentDidMount() {
        this._ismounted = true;


        window.addEventListener('resize', this.updateWindowWidth);

        if (this.props.openOptions <= 0) {
            await this.dajOpcje();
        }

        if(this.props.czyPobytZmieniany && this.props.initialValues.phone.length > 9){

            let prefix = this.props.page.prefiksy.find(x => {
              let p = x.prefiks.substring(1)
              if(p === this.props.initialValues.phone.substring(0, p.length)){
                return x
              }
              return false
            })
      
            if(prefix){
              store.dispatch(Actions.pageState.setLangPhone({ flag: prefix.domena, prefix: prefix.prefiks }));
            }
          }  
    }

    componentWillUnmount() {
        this._ismounted = false;
    }

    setPart = (p: number) => {
        this.setState({part: p})
    }

    //PM 2021-08-13
    //sprawdzenia this._ismounted 
    updateWindowWidth = () => {
        if (this._ismounted)
            this.setState({ ...this.state, width: window.innerWidth });
    }

    //onChangeRemarks = (event: React.ChangeEvent<{ name?: string; value: any }>) => { 
    //    this.setState({remarks: String(event.target.value)})
    //}
    onChangeRemarks = (value: string) => { 
        this.setState({remarks: value})
    }

    checkedValues = () => {
        let checked: string[] = [];
    
        for (let i = 0; i < this.props.options.length; i++) {
          checked.push("0")
        }

        if(this.props.options[13] && this.props.options[13].aktywna === "1" && this.props.options[13].opis.trim() === "auto fkt"){
            checked[13] = "1"
        }
    
        if (this.props.czyPobytZmieniany) {
          checked[2 - 1] = this.props.zmienianyPobyt.tag_uwagi_02;
          checked[3 - 1] = this.props.zmienianyPobyt.tag_uwagi_03;
          checked[4 - 1] = this.props.zmienianyPobyt.tag_uwagi_04;
          checked[5 - 1] = this.props.zmienianyPobyt.tag_uwagi_05;
          checked[6 - 1] = this.props.zmienianyPobyt.tag_uwagi_06;
          checked[7 - 1] = this.props.zmienianyPobyt.tag_uwagi_07;
          checked[8 - 1] = this.props.zmienianyPobyt.tag_uwagi_08;
          checked[9 - 1] = this.props.zmienianyPobyt.tag_uwagi_09;
          checked[11 - 1] = this.props.zmienianyPobyt.tag_uwagi_11;
          checked[12 - 1] = this.props.zmienianyPobyt.tag_uwagi_12;
          checked[13 - 1] = this.props.zmienianyPobyt.tag_uwagi_13;
          checked[14 - 1] = this.props.zmienianyPobyt.tag_uwagi_14;
        }
    
        store.dispatch(Actions.pageState.setOptionsValues(checked));
        this.setState({checked: checked})
        //return checked;
      }

      changeChecked =  (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.checked ? "1" : "0"
        let checked = this.state.checked
        //let checked = this.props.optionsValues
        checked[parseInt(event.target.id)] = val
        this.setState({
         ...this.state,
         checked: checked
        });
         store.dispatch(Actions.pageState.setOptionsValues(checked));
      }

    dajOpcje = async () => {
        try {
            const res = await obiektService.dajTagUwagi({
                hotelId: CONFIG.hotelID,
            }, {});
            //console.log(res)
            await store.dispatch(Actions.pageState.setOptions(res.result));
            this.checkedValues()
        } catch (error) {
            sendErrorLog("0", "-1", '/obiekt/dajTagUwagi')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/obiekt/dajTagUwagi", 2))
            console.error(error)
        }
    }

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    roomPrice = (dokladnosc: number = 0): string => {
        let roomPrice = 0;

        // if (this.props.page.basket[0].ktora_cena === 2)
        //     switch (this.state.persons) {
        //         case 1:
        //             roomPrice = this.props.page.basket[0].cena_os1;
        //             break;
        //         case 2:
        //             roomPrice = this.props.page.basket[0].cena_os2;
        //             break;
        //         case 3:
        //             roomPrice = this.props.page.basket[0].cena_os3;
        //             break;
        //         case 4:
        //             roomPrice = this.props.page.basket[0].cena_os4;
        //             break;
        //     }
        // else
        //     roomPrice = this.props.page.basket[0].price;
        roomPrice = Number(this.props.basket[0].cena);

        if(this.props.page.serwerWersja > 100 && this.state.dostepnosc.length  > 0 ){
            let nums = this.state.dostepnosc.map(x => x.cena_pokoj )
            let sum = 0
            nums.forEach( num => {
                sum += num;
              })
            sum = sum / this.state.dostepnosc.length  
            roomPrice = sum
            roomPrice = Math.round(sum)  //do całości
        }
        let ret =  Number(roomPrice).toFixed(dokladnosc)

        return ret;
    }

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    calculatePrice = () => {
        const d = days(
            new Date(Date.parse(this.state.fromDate)),
            new Date(Date.parse(this.state.toDate))
        );

        const roomPrice = Number(this.roomPrice(2));
        const pokoje = Number(this.state.rooms)

        const sum = Math.round(this.props.basket[0].ktoraCena === '1'
            ? roomPrice : this.props.basket[0].ktoraCena === '2'
                ? roomPrice * this.state.persons * d * pokoje : roomPrice * d * pokoje);
        let sumString = sum.toString();
        sumString = sumString.substring(0, sumString.length - 3)
            + " "
            + sumString.substring(sumString.length - 3, sumString.length);
        return sumString;
    }

    closeDialogInfo = () => {
        this.setState({ ...this.state, openInfo: false });
    }

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    openDialogInfo = (reservation: Rezerwacja) => {
        const { t } = this.props

        const sumString = this.calculatePrice()

        const dialogContent: Content[] = [
            {
                //message: t('Added reservation') 
                message: this.props.czyPobytZmieniany ? t("Reserv change") : t("Reserv make")
            },

            {
                icon: TodayIcon,
                message: t(this.czyUsluga() ? "termin" : "termin") + ': ',
                messageBoldPrimary: reservation.data_od + ' (' + this.getDayOfWeek(reservation.data_od) + ")" 
                + " / " + reservation.data_do + ' (' + this.getDayOfWeek(reservation.data_do) + ")" ,
            },

            {
                icon: Brightness4Icon,
                message: t("Days count") + ': ',
                messageBoldPrimary: days(new Date(reservation.data_od), new Date(reservation.data_do)).toString()
            },

            {
                icon: KingBedIcon,
                message: t(this.czyUsluga() && CONFIG.grafikUslugaOpisAktywny === "1" ? CONFIG.grafikUslugaOpisOpis : this.czyUsluga() ? "Usługa" : "Booking").toLowerCase() + ': ',
                messageBoldPrimary: this.props.basket[0].opis,
            },

            {
                icon: PersonIcon,
                message: t("Person Number") + ': ',
                messageBoldPrimary: reservation.ilosc_osob,
            },

            {                
                icon: MeetingRoomIcon,
                message: t(this.czyUsluga() ? "ilość usług" : "Rooms Number") + ' ', // + ': ',
                messageBoldPrimary: reservation.ilosc_pokoi,
            },

            {
                message: " ",
                messageBoldPrimary: " ",
            },

            {
                icon: PhoneIcon,
                message: t('Your phone') + ': ',
                messageBoldPrimary: phoneSplit(reservation.gosc_telefon),
            },

            {
                icon: EmailIcon,
                message: t('Your email') + ': ',
                messageBoldPrimary: reservation.gosc_e_mail,
            },

            {
                icon: PinIcon, 
                message: t('Your invoice') + ': ', // mz 2022-06-24
                messageBoldPrimary: this.props.daneNIP.nip ? this.props.daneNIP.nip : t('Brak'), //('---'), //t('NOT FOUND').toLowerCase()
                redValue: !this.props.daneNIP.nip
            },

            {
                icon: MonetizationOnIcon,
                message: t('Payment').toLowerCase() + ': ',
                messageBoldPrimary: sumString + ".00 zł",
            },
        ];
        this.setState({ ...this.state, openInfo: true, infoValues: dialogContent, reservation: reservation });
    }

    getDayOfWeek = (param: string) => {
        return moment(param).locale(this.props.page.lang).format('YYYY-MM-DD dd').split(' ')[1].toLowerCase();
    }

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    handleSend = async (values: Values, cena_pokoj: number) => {
        let resdata = new Rezerwacja();
        resdata.data_od = this.state.fromDate;
        resdata.data_do = this.state.toDate;
        // resdata.data_od = this.props.page.dateFrom;
        // resdata.data_do = this.props.page.dateTo;
        resdata.rodz_pokoi = this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.rodz_pokoi : this.props.basket[0].rodzPokoi;
        resdata.www_rodz_pokoi_id = this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.www_rodz_pokoi_id.toString() : this.props.basket[0].id.toString();
        resdata.ilosc_osob = this.state.persons.toString();
        resdata.ilosc_pokoi = this.state.rooms.toString();
        resdata.cena_pokoj = cena_pokoj.toString();
        resdata.ktora_cena = this.props.basket[0].ktoraCena;
        //resdata.gosc_nazwisko = normalizeText(values.surname.toLocaleUpperCase() + " " + values.name.toLocaleUpperCase());
        resdata.gosc_nazwisko = normalizeText(capitalizeAll(values.name));
        resdata.gosc_e_mail = values.email.toLocaleLowerCase().trim();
        resdata.gosc_telefon = values.phone.toString().replace(/\s/g, "");
        resdata.gosc_id = this.props.page.guest.telefon === values.phone.toString().replace(/\s/g, "") ? this.props.page.guest.gosc_id.toString() : ""
        //resdata.notes_tresc = normalizeText(values.remarks);
        resdata.notes_tresc = normalizeText(this.state.remarks);
        resdata.domena = this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.domena : this.props.lang;
        resdata.pokoj_nr = this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.pokoj_nr : this.props.roomNumber.toString();
        resdata.zrodlo_danych = "1";
        resdata.tag_uwagi_02 = this.props.optionsValues[2 - 1];
        resdata.tag_uwagi_03 = this.props.optionsValues[3 - 1];
        resdata.tag_uwagi_04 = this.props.optionsValues[4 - 1];
        resdata.tag_uwagi_05 = this.props.optionsValues[5 - 1];
        resdata.tag_uwagi_06 = this.props.optionsValues[6 - 1];
        resdata.tag_uwagi_07 = this.props.optionsValues[7 - 1];
        resdata.tag_uwagi_08 = this.props.optionsValues[8 - 1];
        resdata.tag_uwagi_09 = this.props.optionsValues[9 - 1];
        resdata.tag_uwagi_11 = this.props.optionsValues[11 - 1];
        resdata.tag_uwagi_12 = this.props.optionsValues[12 - 1];
        resdata.tag_uwagi_13 = this.props.optionsValues[13 - 1];
        resdata.tag_uwagi_14 = this.props.optionsValues[14 - 1];
        resdata.json_wersja_nr = '1';
        resdata.liczba_losowa = await zbudujLiczbeLosowa();
        resdata.status_id = this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.status_id.toString() : '';

        resdata.gosc_dowod_nr = values.dowod.toLocaleUpperCase().trim();
        resdata.gosc_imiona_rodz = values.rodzice.trim();
        resdata.gosc_data_ur = values.dataUrodzenia
        resdata.gosc_miejsce_ur = values.miejsceUrodzenia.trim();
        resdata.gosc_adres = values.adres.trim();
        
        //console.log(resdata)

        this.openDialogInfo(resdata);
    };

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    handleCloseWithoutModal = async () => {
        await store.dispatch(Actions.pageState.setGrafikRefresh( ))
        await store.dispatch(Actions.pageState.handleCloseWithoutModal({ flag: this.props.lang, prefix: '' }));
    }

    sendFailure = async (dokNr: number) => {
        try {
            await bookService.reservCancel(
                {
                    hotelId: CONFIG.hotelID,
                    aOperatorId: Number(sessionStorage.getItem("operator_id")),
                    aPobytId: Number(dokNr) || 0
                }, {})
                sendErrorLog("1", "1", 'anulowanie rezerwacji')
                store.dispatch(Actions.pageState.addFcmLogMessage("anulowanie rezerwacji", 2))
            //console.log(res)    
        } catch (error) {
            await sendErrorLog("0", "-1", '/manager/recepcjaPobytAnuluj')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaPobytAnuluj", 2))
            console.log(error);
        }
    }

    //PM 2021-11-16
    //await store.dispatch(Actions.pageState.handleClose(...)
    handleClose = async () => {
        await store.dispatch(Actions.pageState.handleClose({ flag: this.props.lang, prefix: '' }));
    };

    redirectToPaymentCashBill = async (dokNr: number, kwota: string) => {
        console.log("redirectToPayment")
        let id = ""
        let link = ''
        try {
            const res = await payService.getPaymentUrl({ hotelId: CONFIG.hotelID, dokNr: dokNr.toString(), kwota: kwota, opis: "Testowa platnosc" })
            //console.log(res)
            id = res.id

            if (id){
                link = res.redirectUrl
                window.open(res.redirectUrl, '_blank');
                await sendErrorLog("1", "1", "rozpoczecie platnosci CashBill")
                await store.dispatch(Actions.pageState.addFcmLogMessage("rozpoczecie platnosci CashBill", 0))    
            }
                   
            //window.open(window.location.href + 'testPlatnosci', '_blank');
        } catch (error) {
            await sendErrorLog("0", "-1", '/pay/payCashBillZaplac')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/pay/payCashBillZaplac", 2))
            console.log(error)
            this.handleCloseWithoutModal();
        }

        return {id: id, link: link}
    }

    redirectToPaymentPrzelewy24 = async (dokNr: number, kwota: number, reservation: Rezerwacja): string => {
        console.log("redirectToPayment")
        let dateNow = new Date()
        let dateReservation = new Date(reservation.data_od)

        dateNow.setHours(2)
        dateReservation.setHours(4)

        let diff = datediff(dateNow, dateReservation)

        //let preautoryzacja = diff <= 2 ? "0" : "1"
        //await store.dispatch(Actions.pageState.setPreautoryzacja(Number(preautoryzacja)))

        let ret = ""
        try {
            let res: vscPaymentPrzelewy24
            if (CONFIG.payWebPotwierdzAktywny === "0") { //nowe


                let potwierdzParametry = {
                    hotelId: CONFIG.hotelID,
                    aoperatorId: Number(1),
                    apobytId: Number(dokNr),
                }


                res = await payServicePrzelewy24.zaplac2({
                    aJSON: {
                        hotelId: CONFIG.hotelID,
                        vscPreautoryzacja: this.props.preautoryzacja.toString(),
                        vscId: dokNr,
                        vscKwota: kwota,
                        vscOpis: "Platnosc za pobyt: " + String(dokNr),
                        returnUrl: CONFIG.apiURL + "/hotel/" + CONFIG.hotelID,
                        email: "pytania@virtualsc.com.pl",
                        kanal: "",
                        prefiks: CONFIG.payWebPrefiks,
                        kontoId: CONFIG.payWebKontoId,

                        wsPotwierdzNazwa: "https://vsc24.net/vscHotelBook/manager/recepcjaPobytPotwierdz",
                        wsPotwierdzParametry: JSON.stringify(potwierdzParametry),
                        wsPotwierdzBrakGetPost: "2",
                        smsBrakWszystkieKoniecError: "1",
                    }
                })

            } else { //po staremu

                res = await payServicePrzelewy24.getPaymentUrl({
                    hotelId: CONFIG.hotelID,
                    //vscPreautoryzacja: preautoryzacja,
                    vscPreautoryzacja: this.props.preautoryzacja.toString(),
                    vscId: dokNr,
                    vscKwota: kwota,
                    vscOpis: "Platnosc za pobyt: " + String(dokNr),
                    returnUrl: CONFIG.apiURL + "/hotel/" + CONFIG.hotelID, //okUrl: CONFIG.apiURL + "/hotel/" + CONFIG.hotelID + "/OK", notOkUrl: CONFIG.apiURL + "/hotel/" + CONFIG.hotelID + "/NotOK"
                    email: reservation.gosc_e_mail ? reservation.gosc_e_mail : "pytania@virtualsc.com.pl",
                    prefiks: CONFIG.payWebPrefiks,
                    kontoId: CONFIG.payWebKontoId,
                })


            } 

            
            //console.log(res)

            if (res.result && res.code === 0) {
                //await this.setState({link: res.result})
                ret = res.result
                window.open(res.result, '_blank');
                await sendErrorLog("1", "1", "rozpoczecie platnosci Przelewy24")
                await store.dispatch(Actions.pageState.addFcmLogMessage("rozpoczecie platnosci Przelewy24", 0))
            } else {
                ret = ""
                throw "/przelewy24/zaplac"
            }

            //window.open(window.location.href + 'testPlatnosci', '_blank');
        } catch (error) {
            await sendErrorLog("0", "-1", '/przelewy24/zaplac')
            await store.dispatch(Actions.pageState.addFcmLogMessage("/przelewy24/zaplac", 2))
            console.log(error)
            ret = ""
            this.handleCloseWithoutModal();

        }
        return ret
    }

    //PM 2021-11-16
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    //sessionStorage.removeItem("zapisanyFormularz")
    sendReservation = async (reservation: Rezerwacja, t: TFunction) => {

        try {

            let res: ReservationId

            if(!this.disabledAll){ //tylko zmiana faktóry

            res = this.props.czyPobytZmieniany
                ? await bookService.pobytZmien({ hotelId: CONFIG.hotelID, aOperatorId: 1, aPobytId: Number(this.props.zmienianyPobyt.pobyt_id), body: reservation })
                : await bookService.reservNew({ hotelId: CONFIG.hotelID, aOperatorId: 1, body: reservation })
            } else {
                res = {result: [this.props.zmienianyPobyt.pobyt_id]}
            }

            if(this.props.daneNIP.nip && res.result.length > 0 || this.disabledAll){ // mz 2022-06-24
                if(res.result[0] !== 0){

                    let nip = this.props.daneNIP.nip.trim()
                    if(nip[0] &&(nip[0] === "." || nip[0] === "," || nip[0] === "-")){
                    nip = nip.substring(1, nip.length)
                    }
                    
                    let id = this.disabledAll ? this.props.zmienianyPobyt.pobyt_id : res.result[0] 

                    await nipService.dodajKontrahentDlaPobyt({
                        hotelId: CONFIG.hotelID,
                        pobytId: id,
                        nip: nip,
                        adres: this.props.daneNIP.adres,
                        kontrNazwa: this.props.daneNIP.kontrNazwa,
                    })  
                }
            }
        
            
            const dialogContentSuccess: Content[] = [
                { message: t('Added reservation') },

                {
                    icon: EventAvailableIcon,
                    message: t("Booking") + ' ',
                    messageBoldPrimary: this.disabledAll ? String(this.props.zmienianyPobyt.pobyt_id) : String(res.result),
                },

                {
                    icon: TodayIcon,
                    message: t(this.czyUsluga() ? "termin" : "termin") + ' ',
                    messageBoldPrimary: reservation.data_od + ' (' + this.getDayOfWeek(reservation.data_od) + ")"
                    + " / " + reservation.data_do + ' (' + this.getDayOfWeek(reservation.data_do) + ")",
                },

                {
                    icon: KingBedIcon,
                    message: t(this.czyUsluga() && CONFIG.grafikUslugaOpisAktywny === "1" ? CONFIG.grafikUslugaOpisOpis : this.czyUsluga() ? "Usługa" : "pokój").toLowerCase() + ' ',
                    messageBoldPrimary: this.props.basket[0].opis,
                },

                {
                    icon: PersonIcon,
                    message: t("Person Number") + ' ',
                    messageBoldPrimary: reservation.ilosc_osob,
                },

                {
                    icon: MeetingRoomIcon,
                    message: t(this.czyUsluga() ? "ilość usług" : "Rooms Number") + ' ', // + ': ',
                    messageBoldPrimary: reservation.ilosc_pokoi,
                },

                {
                    message: " ",
                    messageBoldPrimary: " ",
                },

                {
                    icon: PhoneIcon,
                    message: t('Your phone') + ' ',
                    messageBoldPrimary: phoneSplit(reservation.gosc_telefon),
                },

                {
                    icon: EmailIcon,
                    message: t('Your email') + ' ',
                    messageBoldPrimary: reservation.gosc_e_mail,
                },

                {
                    icon: PinIcon, 
                    message: t('Your invoice') + ' ', // mz 2022-06-24
                    messageBoldPrimary: this.props.daneNIP.nip ? this.props.daneNIP.nip : t('Brak'), //('---'), //t('NOT FOUND').toLowerCase()
                    redValue: !this.props.daneNIP.nip
                },

                {
                    icon: CheckIcon, 
                    message: t('Confirmation').toLowerCase() + ' ',
                    messageBoldPrimary: t("Send"),
                },

                {
                    icon: CheckCircleIcon,
                    message: "",
                    messageBoldPrimary: t("Invite"),
                }

            ];

            const dialogContentSuccessSms: Content[] = [
                { message: t('Proszę czekać na potwierdzenie rezerwacji') },
                {
                    icon: SmsIcon,
                    message: t("potwierdzenie otrzymasz sms-em") + ' ', // + ': ',
                    //messageBoldPrimary: this.disabledAll ? String(this.props.zmienianyPobyt.pobyt_id) : String(res.result),
                },
                // {
                //     message: " ",
                //     messageBoldPrimary: " ",
                // },
                {
                    icon: CheckCircleIcon,
                    message: "",
                    messageBoldPrimary: t("Invite"),
                }
            ];

            //sessionStorage.setItem('dialog_content_success', JSON.stringify(dialogContentSuccess));

            const dialogContentFailure: Content[] = [
                { message: t("Reservation Failure") },

                {
                    message: wciecie + t(this.czyUsluga() ? "termin" : "termin") + ' ',
                    messageBoldPrimary: reservation.data_od + " / " + reservation.data_do
                },

                {
                    message: wciecie + t(this.czyUsluga() && CONFIG.grafikUslugaOpisAktywny === "1" ? CONFIG.grafikUslugaOpisOpis : this.czyUsluga() ? "Usługa" : "Booking").toLowerCase() + ' ',
                    messageBoldPrimary: this.props.basket[0].opis
                },

                {
                    message: wciecie + t("Person Number") + ' ',
                    messageBoldPrimary: reservation.ilosc_osob
                },

                {
                    message: wciecie + t(this.czyUsluga() ? "ilość usług" : "Rooms Number") + ' ', // + ': ',
                    messageBoldPrimary: reservation.ilosc_pokoi,
                },

                // {message: wciecie + t('Your phone') + ': ',
                // messageBoldPrimary: reservation.gosc_telefon},

                // {message: wciecie + t('Your email') + ': ',
                // messageBoldPrimary: reservation.gosc_e_mail},  

                {
                    message: " ",
                    messageBoldPrimary: " "
                },

                {
                    message: wciecie,
                    messageBoldPrimary: t("Agin")
                },


                {
                    message: wciecie,
                    messageBoldPrimary: t("Phone Contact")
                }

            ];
            //sessionStorage.setItem('dialog_content', JSON.stringify(dialogContentFailure));
            if (res.result[0] > 0) {
                const sumString = this.calculatePrice().split(" ").join("")
                let id = ""
                let link = ""
                
                if (!this.disabledAll) {
                    if (!(CONFIG.platnoscLink === "0" && !this.props.czyPobytZmieniany && (this.props.contact.payWeb === "1" || this.props.contact.payWeb === "2"))) {
                        switch (this.props.contact.payWeb) {
                            case "2": //CashBill
                                let ret1 = await this.redirectToPaymentCashBill(res.result[0], sumString);
                                id = ret1.id
                                link = ret1.link
                                localStorage.setItem("rezerwacja", String(res.result) + ":" + reservation.gosc_telefon)
                                break;
                            case "1": //Przelewy24

                                let ret2 = await this.redirectToPaymentPrzelewy24(res.result[0], Number(sumString + "00"), reservation);
                                id = ret2 ? String(res.result) : ""
                                link = ret2
                                if (id !== "") localStorage.setItem("rezerwacja", String(res.result) + ":" + reservation.gosc_telefon)
                                break;
                            //case "5": //TPay

                            //    break;

                            default:
                                break;
                        }
                    }
                }

                //id = "1"  //Test płatności


                // let data = {
                //     paymentId: id,
                //     reservationId: res.result,
                //     dialogContent: dialogContentSuccess,
                //     dialogContentFailure: dialogContentFailure,
                //     reservation: reservation,
                //     success: true,
                //     handleClose: this.handleCloseWithoutModal,
                //     roomDescription: this.props.page.basket[0].opis,
                // }
                await store.dispatch(Actions.pageState.addFcmLogMessage("wyslanie rezerwacji", 0))
                if (id || this.props.contact.payWeb === "0" || this.props.contact.payWeb === "5" || this.disabledAll || (CONFIG.platnoscLink === "0" && !this.props.czyPobytZmieniany && (this.props.contact.payWeb === "1" || this.props.contact.payWeb === "2"))) {
                    // await store.dispatch(Actions.pageState.setNotifierData(data));
                    // const sumString = this.calculatePrice()
                    // await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
                    // await store.dispatch(Actions.pageState.setPlatnosciOpen(Number(sumString), res.result));


                    ReactDOM.render(
                        <Provider store={store}>
                            <MuiThemeProvider theme={ selectTheme(this.props.theme) }>
                                <Notifier
                                    //messagePart1={t("Your reservation has number")}                     
                                    //messagePart2={t("Thank You for reservation. Confirmation has been sent to your e-mail address")} 
                                    paymentId={id}
                                    reservationId={res.result[0]}
                                    dialogContent={this.props.contact.payWeb === "5" ? dialogContentSuccessSms : dialogContentSuccess}
                                    dialogContentFailure={dialogContentFailure}
                                    title={t("Success")}
                                    titleFailure={t("Failure").toLowerCase()}
                                    reservation={reservation}
                                    success={true}
                                    handleClose={this.handleCloseWithoutModal}
                                    paymentLink={link}
                                    roomDescription={this.props.basket[0].opis} />
                            </MuiThemeProvider>
                        </Provider>,
                        document.getElementById("dialog"));
                    await store.dispatch(Actions.pageState.setNotifierOpen());
                    await sendErrorLog("1", "1", "wyslanie rezerwacji sukces")
                    await store.dispatch(Actions.pageState.addFcmLogMessage("wyslanie rezerwacji sukces", 0))  
                    ReactGA.event({
                        category: 'Akcje',
                        action: 'Rezerwacja pokoju'
                    });
                }
                else {
                    await this.sendFailure(res.result[0]);

                    const dialogContentFailure = [
                        { message: t("Reservation Failure") },
                        { message: wciecie + t("Internet payment failure") },
                        {
                            message: " ",
                            messageBoldPrimary: " "
                        },
                        {
                            message: wciecie,
                            messageBoldPrimary: t("Agin")
                        },
                        {
                            message: wciecie,
                            messageBoldPrimary: t("Phone Contact")
                        }

                    ];

                    ReactDOM.render(
                        <Provider store={store}>
                           <MuiThemeProvider theme={ selectTheme(this.props.theme) }>
                                <Notifier
                                    reservationId={res.result[0]}
                                    dialogContent={dialogContentSuccess}
                                    dialogContentFailure={dialogContentFailure}
                                    titleFailure={t("Failure").toLowerCase()}
                                    success={false}
                                    handleClose={this.handleCloseWithoutModal}
                                    roomDescription={this.props.basket[0].opis} />
                            </MuiThemeProvider>
                        </Provider>
                        , document.getElementById("dialog"));
                    await store.dispatch(Actions.pageState.setNotifierOpen());
                    await sendErrorLog("1", "1", "wyslanie rezerwacji blad platnosci")
                    await store.dispatch(Actions.pageState.addFcmLogMessage("wyslanie rezerwacji blad platnosci", 0)) 
                }
                //alert("Twoja rezerwacja ma numer "+res.id+".\nDziękujemy za złożenie rezerwacji.\nPotwierdzenie zostało wysłane na Twój adres e-mail.");
            } else {
                ReactDOM.render(
                    <Provider store={store}>
                        <MuiThemeProvider theme={ selectTheme(this.props.theme) }>
                            <Notifier
                                reservationId={res.result[0]}
                                dialogContent={dialogContentSuccess}
                                dialogContentFailure={dialogContentFailure}
                                messagePart1={t("Unable to add reservation within the given period. Please, contact us by phone")}
                                titleFailure={t("Failure").toLowerCase()}
                                success={false}
                                handleClose={this.handleCloseWithoutModal}
                                roomDescription={this.props.basket[0].opis} />
                        </MuiThemeProvider>
                    </Provider>
                    , document.getElementById("dialog"));
                await store.dispatch(Actions.pageState.setNotifierOpen());
                await sendErrorLog("1", "1", "wyslanie rezerwacji porazka")
                await store.dispatch(Actions.pageState.addFcmLogMessage("wyslanie rezerwacji porazka", 0))
                //alert("Nie można dodać rezerwacji w podanym okresie.\nProsimy o kontakt telefoniczny.")         
            }
            sessionStorage.removeItem("zapisanyFormularz")
            this.handleClose();
        } catch (error) {
            await sendErrorLog("0", "-1", this.props.czyPobytZmieniany ? 'zmiana pobytu' : 'wysłanie rezerwacji')
            await store.dispatch(Actions.pageState.addFcmLogMessage(this.props.czyPobytZmieniany ? 'zmiana pobytu' : 'wysłanie rezerwacji', 2))
            //alert('NIEPOWODZENIE!');
            console.log(error)
            await this.handleCloseWithoutModal();
        }
    }

    //PM 2021-08-13
    submitDialogInfo = async () => {
        const { t } = this.props


        if( CONFIG.platnoscLink === "0" && !this.props.czyPobytZmieniany && (this.props.contact.payWeb === "1" || this.props.contact.payWeb === "2")){
            ReactDOM.render(
                <Provider store={store}>
                    <MuiThemeProvider theme={ selectTheme(this.props.theme) }>
                        <DialogNoPayment randomNum={Math.random()} submit={this.submitDialogInfoAction}/>
                    </MuiThemeProvider>
                </Provider>,
                document.getElementById("dialog"));
        } else {

        await this.submitDialogInfoAction()
        }
    }

    submitDialogInfoAction = async () => {
        const { t } = this.props

        await store.dispatch(Actions.pageState.setOptionsValues(["0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0", "0"]));
        await store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));
        await store.dispatch(Actions.pageState.closeDialogZarzadzaj());
        this.sendReservation(this.state.reservation, t);   
    }

    // sprawdza, czy jest dostępność pokoju z koszyka w okresie od aDataOd do aDataDo
    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    getDetails = async (aDataOd: string, aDataDo: string): Promise<boolean> => {
        let ret = false;

        try {
            // vscTest
            // alert(aDataOd + '\n' + aDataDo)

            const res = this.props.czyPobytZmieniany ?
                await obiektService.dajPokojeWolne(
                    {
                        hotelId: CONFIG.hotelID,
                        pobytId: String(this.props.zmienianyPobyt.pobyt_id),
                        rodzPokoi: this.props.zmienianyPobyt.rodz_pokoi,
                        dataOd: aDataOd,
                        dataDo: aDataDo,
                        domena: this.props.lang,
                    }, {}
                ) :
                await obiektService.dajPokojeDostepne(
                    {
                        hotelId: CONFIG.hotelID,
                        domena: this.props.lang,
                        rodzPokoi: this.props.basket[0].rodzPokoi,
                        dataOd: aDataOd,
                        dataDo: aDataDo,
                    }, {}
                );

                let resCeny :Dostepnosc = {result: []}
                if(this.props.page.serwerWersja > 100){
                    resCeny = await bookService.dajCeny(
                        {
                            hotelId: CONFIG.hotelID,
                            aOperatorId: Number(sessionStorage.getItem("operator_id")),
                            //lang: this.props.page.lang,
                            aRodzPokoiId: this.props.basket[0].rodzPokoi,
                            aDataOd: aDataOd,
                            aDataDo: aDataDo,
                            //aDataDo: daysFromDate(new Date(dataDo), 1)
                            //d
                        }, {}
                      ) 
                      this.setState({dostepnosc: resCeny.result,})
                }

            //console.log(res)
            if (Array.isArray(res.result) && res.result.length) {
                this.setState({freeRooms: res.result.length -1})  
                if(res.result.length -1 < this.state.rooms){
                    this.setState({rooms: res.result.length -1 || 1})  
                }
                const znalezionyPokoj = res.result.find(p => p.pokoj === this.props.zmienianyPobyt.pokoj_nr);

                if (!znalezionyPokoj)
                    await store.dispatch(Actions.pageState.setZmienianyPobyt({ ...this.props.zmienianyPobyt, pokoj_nr: String(res.result[0].pokoj) }));


                ret = true;
            } else {
                //this.setState({...this.state, vacantRooms : res.vacantRooms})
                this.setState({ ...this.state, openError: true, fromDateError: aDataOd, toDateError: aDataDo });
                ret = false;
            }
            //                alert(JSON.stringify(res)) 
            //this.setState({...this.state, 
            //  details : res})
        } catch (err) {
            await sendErrorLog("0", "-1", 'sprawdzenie dostępności pokoju')
            await store.dispatch(Actions.pageState.addFcmLogMessage("sprawdzenie dostępności pokoju", 2))
            console.log(err);
        }

        return ret;
    }

    handleDateFromChange = async (dateParam: MaterialUiPickersDate) => {
        if (dateParam) {
            const date = new Date(dateParam.toISOString());

            this.setState({ ...this.setState, fromDate: formatDate(date) });
        }
    };

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    setDateFrom = async (dateParam: MaterialUiPickersDate) => {
        if (dateParam) {
            let date = new Date(dateParam.toISOString());
            let dateTo: Date = new Date();
            const a = formatDate(date);

            // jeśli zmieniamy pobyt zmieniamy dataDo o taką samą wartość
            if (this.props.czyPobytZmieniany) {
                const wartosc = days(new Date(this.state.fromDate), date);
                dateTo = new Date(this.state.toDate);
                dateTo.setDate(dateTo.getDate() + wartosc);
            }
            else {
                const ilosc_dni_min = Number(this.props.basket[0].minIloscDni) > 1 ? Number(this.props.basket[0].minIloscDni) : 1;
                dateTo = new Date(date);
                dateTo.setDate(dateTo.getDate() + ilosc_dni_min);
            }

            // jeśli trzeba także zwiększyć dataDo
            // jeśli pobyt zmieniany, to zawsze zmieniamy dataDo
            if ((dateTo.getTime() >= (new Date(this.state.toDate)).getTime()) || this.props.czyPobytZmieniany) {
                const res = await this.getDetails(a, formatDate(dateTo));
                if (res) {
                    this.setState({
                        ...this.setState,
                        fromDatePrev: a,
                        toDatePrev: formatDate(dateTo),
                        fromDate: a,
                        toDate: formatDate(dateTo),
                    });
                } else {
                    this.setState({
                        ...this.setState,
                        fromDate: this.state.fromDatePrev,
                        toDate: this.state.toDatePrev
                    });
                }
                // jeśli nie trzeba zwiększać dataDo
            } else {
                const res = await this.getDetails(a, this.state.toDate);
                if (res) {
                    this.setState({
                        ...this.setState,
                        fromDatePrev: a,
                        fromDate: a
                    });
                } else {
                    this.setState({
                        ...this.setState,
                        fromDate: this.state.fromDatePrev
                    });
                }
            }
        }
    };

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    minusDayFrom = async () => {
        const date = new Date(new Date(this.state.fromDate).setDate(new Date(this.state.fromDate).getDate() - 1));
        const warunek = this.props.czyPobytZmieniany ?
            date.getTime() >= new Date(this.props.zmienianyPobyt.pobyt_od).getTime() : date.getTime() >= new Date(new Date().setDate(new Date().getDate() - 1)).getTime();

        // jeśli dataOd nie jest w przeszłości lub (jeśli pobyt zmieniany) nie jest przed pobyt_od
        if (warunek) {
            // jeśli pobyt zmieniany, minusujemy także dataDo
            if (this.props.czyPobytZmieniany) {
                const dateTo = new Date(new Date(this.state.toDate).setDate(new Date(this.state.toDate).getDate() - 1));
                const dateString = formatDate(date);
                const dateToString = formatDate(dateTo);
                const res = await this.getDetails(dateString, dateToString);
                if (res) {
                    this.setState({
                        ...this.setState,
                        fromDatePrev: dateString,
                        fromDate: dateString,
                        toDatePrev: dateToString,
                        toDate: dateToString,
                    });
                } else {
                    this.setState({
                        ...this.setState,
                        fromDate: this.state.fromDatePrev,
                        toDate: this.state.toDatePrev,
                    });
                }
            }
            // jeśli pobyt nie zmieniany
            else {
                const res = await this.getDetails(formatDate(date), this.state.toDate);
                if (res) {
                    this.setState({
                        ...this.setState,
                        fromDatePrev: formatDate(date),
                        fromDate: formatDate(date)
                    });
                } else {
                    this.setState({
                        ...this.setState,
                        fromDate: this.state.fromDatePrev
                    });
                }
            }
        }
    };

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    plusDayFrom = async () => {
        const date = new Date(new Date(this.state.fromDate).setDate(new Date(this.state.fromDate).getDate() + 1));
        let dateTo = new Date(date);
        const ilosc_dni_min = Number(this.props.basket[0].minIloscDni) > 1 ? Number(this.props.basket[0].minIloscDni) : 1;
        dateTo = new Date(dateTo.setDate(dateTo.getDate() + ilosc_dni_min));
        const datePlusDayDifference = new Date(new Date(this.state.fromDate).setDate(new Date(this.state.fromDate).getDate() + ilosc_dni_min));
        const a = formatDate(date);

        // jeśli pobyt zmieniany to plusujemy także dataDo
        if (this.props.czyPobytZmieniany) {
            const dateTo = new Date(new Date(this.state.toDate).setDate(new Date(this.state.toDate).getDate() + 1));
            const dateToString = formatDate(dateTo);
            const res = await this.getDetails(a, dateToString);
            if (res) {
                this.setState({
                    ...this.setState,
                    fromDatePrev: a,
                    toDatePrev: dateToString,
                    fromDate: a,
                    toDate: dateToString
                });
            } else {
                this.setState({
                    ...this.setState,
                    fromDate: this.state.fromDatePrev,
                    toDate: this.state.toDatePrev
                });
            }
        }
        // jeśli pobyt nie zmieniany
        else {
            if (datePlusDayDifference.getTime() >= (new Date(this.state.toDate)).getTime()) {
                const res = await this.getDetails(a, formatDate(dateTo));
                if (res) {
                    this.setState({
                        ...this.setState,
                        fromDatePrev: a,
                        toDatePrev: formatDate(dateTo),
                        fromDate: a,
                        toDate: formatDate(dateTo)
                    });
                } else {
                    this.setState({
                        ...this.setState,
                        fromDate: this.state.fromDatePrev,
                        toDate: this.state.toDatePrev
                    });
                }
            } else {
                const res = this.getDetails(a, this.state.toDate);
                if (res) {
                    this.setState({
                        ...this.setState,
                        fromDatePrev: a,
                        fromDate: a
                    });
                } else {
                    this.setState({
                        ...this.setState,
                        fromDate: this.state.fromDatePrev
                    });
                }
            }
        }
    };

    handleDateToChange = (dateParam: MaterialUiPickersDate) => {
        if (dateParam) {
            const date = new Date(dateParam.toISOString());

            this.setState({ ...this.setState, toDate: formatDate(date) });
        }
    };

    // PM 2021-02-19
    setDateTo = async (dateParam: MaterialUiPickersDate) => {
        if (dateParam) {
            const date = new Date(dateParam.toISOString());

            const res = await this.getDetails(this.state.fromDate, formatDate(date));
            if (res) {
                this.setState({
                    ...this.setState,
                    toDatePrev: formatDate(date),
                    toDate: formatDate(date)
                });
            } else {
                this.setState({
                    ...this.setState,
                    toDate: this.state.toDatePrev
                });
            }
        }
    };

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    minusDayTo = async () => {
        const t = this.props.t;
        const date = new Date(new Date(this.state.toDate).setDate(new Date(this.state.toDate).getDate() - 1));
        const ilosc_dni_min = Number(this.props.basket[0].minIloscDni) > 1 ? Number(this.props.basket[0].minIloscDni) : 1;

        if (date > new Date(new Date(this.state.fromDate).setDate(new Date(this.state.fromDate).getDate() + (ilosc_dni_min > 1 ? ilosc_dni_min - 1 : 0)))) {
            const res = await this.getDetails(this.state.fromDate, formatDate(date));
            if (res) {
                this.setState({
                    ...this.setState,
                    toDatePrev: formatDate(date),
                    toDate: formatDate(date)
                });

            } else {
                this.setState({
                    ...this.setState,
                    toDate: this.state.toDatePrev
                });
            }
        }
        else {
            const dialogContent = [
                { message: t('The minimum stay is') + ' ' + this.props.basket[0].minIloscDni + ' ' + t('Days') + '.' }
            ];

            ReactDOM.render(
                <Provider store={store}>
                    <MuiThemeProvider theme={ selectTheme(this.props.theme) }>
                        <Notifier
                            //messagePart1={t("Your reservation has number")}                     
                            //messagePart2={t("Thank You for reservation. Confirmation has been sent to your e-mail address")} 
                            dialogContentFailure={dialogContent}
                            dialogContent={dialogContent}
                            titleFailure={t("Warning")}
                            success={false}
                            yellow
                            roomDescription={this.props.basket[0].opis} />
                    </MuiThemeProvider>
                </Provider>,
                document.getElementById("dialog"));
            await store.dispatch(Actions.pageState.setNotifierOpen());
        }
    };

    // PM 2021-02-19
    plusDayTo = async () => {
        const date = new Date(new Date(this.state.toDate).setDate(new Date(this.state.toDate).getDate() + 1));

        const res = await this.getDetails(this.state.fromDate, formatDate(date));
        if (res) {
            this.setState({
                ...this.setState,
                toDatePrev: formatDate(date),
                toDate: formatDate(date)
            });

        } else {
            this.setState({
                ...this.setState,
                toDate: this.state.toDatePrev
            });
        }
    };

    ///////////////////////////////////////////////////////////////////////////////////////////////
    opcjeMenu = (maxOsob: number) => {
        let opcje: number[] = []
        for (let i = 1; i <= maxOsob; i++) {
            opcje.push(i);
        }
        return opcje
    }

    zmienIloscOsob = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        this.setState({
            ...this.setState,
            persons: Number(event.target.value),
        });
    }

    zmienIloscPokoi = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
        this.setState({
            ...this.setState,
            rooms: Number(event.target.value),
        });
    }

    //PM 2021-11-10
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    leftFields = (): FormFields[] => {
        const { t, classes } = this.props;
        const d = days(
            new Date(Date.parse(this.state.fromDate)),
            new Date(Date.parse(this.state.toDate))
        );
        const minData = this.state.fromDate.substring(0, 8)
            + (
                parseInt(this.state.fromDate.substring(8), 10)
                + (
                    // this.props.page.basket[0].ilosc_dni_min > 1 ? this.props.page.basket[0].ilosc_dni_min : 1
                    1
                )
            );

            //cena 123,12
            let roomPriceString = this.roomPrice(2).toString();
            let num = roomPriceString.split(".")[0]
            let rest = roomPriceString.split(".")[1]

            roomPriceString = num.substring(0, num.length - 3)
            + " "
            + num.substring(num.length - 3, num.length)
            + "," + rest + " zł za " + this.props.basket[0].ktoraCenaOpis

        //const roomPriceString = this.props.basket[0].cena + ' zł za ' + this.props.basket[0].ktoraCenaOpis;
        const sumString = this.calculatePrice()

        return [
            {
                block:
                {
                    type: FieldTypes.date,
                    props: {
                        formControlStyle:{ marginTop: "20px",},
                        key: String(t(FormularzLabels.Przyjazd)),
                        label: t(this.czyUsluga() ? "Termin od" : FormularzLabels.Przyjazd) + '',
                        labelSecondary: true,
                        value: this.state.fromDate,
                        onChange: this.handleDateFromChange,
                        onAccept: this.setDateFrom,
                        minDate: this.props.czyPobytZmieniany ? new Date(this.props.zmienianyPobyt.pobyt_od) : new Date(),
                        inputClasses: `${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.textSecondary}`,
                        style: {
                            width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.DATA.value.mobile : PoleDlugosciJednoWWierszu.DATA.value.PC,
                             marginRight: "3px"
                        },
                        onMinus: this.minusDayFrom,
                        onPlus: this.plusDayFrom,
                        cancelLabel: t("Back"),
                        showTodayButton: true,
                        todayLabel: t("Today"),
                        disabled: this.disabledAll,
                        leftBold: true,
                        endAdornment: (
                            <InputAdornment position="end">
                              <IconButton>
                                <EventIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                    },
                },
            },
            {
                block:
                {
                    type: FieldTypes.date,
                    props: {
                        key: String(t(FormularzLabels.Wyjazd)),
                        label: t(this.czyUsluga() ? "Termin do" : FormularzLabels.Wyjazd) + '',
                        labelSecondary: true,
                        formControlStyle:{ marginBottom: "30px" },
                        value: this.state.toDate,
                        onChange: this.handleDateToChange,
                        onAccept: this.setDateTo,
                        minDate: minData,
                        inputClasses: `${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.textSecondary}`,
                        style: {
                            width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.DATA.value.mobile : PoleDlugosciJednoWWierszu.DATA.value.PC,
                             marginRight: "3px"
                        },
                        onMinus: this.minusDayTo,
                        onPlus: this.plusDayTo,
                        cancelLabel: t("Back"),
                        disabled: this.disabledAll,
                        rightBold: true,
                        endAdornment: (
                            <InputAdornment position="end">
                              <IconButton>
                                <EventIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                    },
                },
            },
            {
                block:
                {
                    type: FieldTypes.text,
                    props: {
                        key: String(t(FormularzLabels.Pokoj)),
                        label: t(this.czyUsluga() && CONFIG.grafikUslugaOpisAktywny === "1" ? capitalizeFirstLetter(CONFIG.grafikUslugaOpisOpis) : this.czyUsluga() ? "Usługa" : FormularzLabels.Pokoj) + '',
                        labelSecondary: true,
                        style: { width: this.state.width <= mobileBreakpoint ? PoleDlugosciJednoWWierszu.DATA.value.mobile : PoleDlugosciJednoWWierszu.DATA.value.PC, },
                        inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.textSecondary}`,
                        value: this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.rodz_pokoi_opis : this.props.basket[0].opis,
                        disabled: true,
                    },
                },
            },
            {
                inline: [
                    {
                        type: FieldTypes.text,
                        props: {
                            key: String(t(FormularzLabels.Cena)),
                            formControlStyle: {
                                //marginBottom: 0, paddingBottom: "25.6px",
                                marginBottom: "30px",
                                display: 'inline-block', height: '35px',
                                width: this.state.width <= mobileBreakpoint
                                    ? PoleDlugosciDwaWWierszu.LEWE.value.formControl.mobile : PoleDlugosciDwaWWierszu.LEWE.value.formControl.PC,
                            },
                            label: t(FormularzLabels.Cena) + '',
                            labelStyle: {
                                width: this.state.width <= mobileBreakpoint
                                    ? PoleDlugosciDwaWWierszu.LEWE.value.label.mobile : PoleDlugosciDwaWWierszu.LEWE.value.label.PC,
                            },
                            labelSecondary: true,
                            style: {
                                width: this.state.width <= mobileBreakpoint
                                    ? PoleDlugosciDwaWWierszu.LEWE.value.field.mobile : PoleDlugosciDwaWWierszu.LEWE.value.field.PC,
                            },
                            inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.textSecondary}`,
                            value: roomPriceString,
                            disabled: true,
                        },
                    },
                    {
                        type: FieldTypes.text,
                        props: {
                            key: FormularzLabels.Doby,
                            formControlStyle: {
                                //marginBottom: 0, paddingBottom: "25.6px",
                                display: 'inline-block', height: '35px',
                                width: this.state.width <= mobileBreakpoint
                                ? PoleDlugosciDwaWWierszu.PRAWE.value.formControl.mobile : PoleDlugosciDwaWWierszu.PRAWE.value.formControl.PC,
                            },
                            label: FormularzLabels.Doby,
                            labelStyle: {
                                width: this.state.width <= mobileBreakpoint
                                ? PoleDlugosciDwaWWierszu.PRAWE.value.label.mobile : PoleDlugosciDwaWWierszu.PRAWE.value.label.PC,
                                textAlign: "center"
                            },
                            labelSecondary: true,
                            style: {
                                width: this.state.width <= mobileBreakpoint
                                ? PoleDlugosciDwaWWierszu.PRAWE.value.field.mobile : PoleDlugosciDwaWWierszu.PRAWE.value.field.PC,
                            },
                            inputClasses: `${classes.floatLeft} ${classes.textAlignCenter} ${classes.fontWeightNormal} ${classes.textSecondary}`,
                            value: d,
                            disabled: true,
                        }
                    }
                ],
            },
            {
                block:
                {
                    type: FieldTypes.select,
                    props: {
                        key: String(t(FormularzLabels.Osoby)),
                        label: t(FormularzLabels.Osoby) + '',
                        labelSecondary: true,
                        className: `${classes.backgroundWhite} ${classes.textSecondary}`,
                        data: this.opcjeMenu(this.props.czyPobytZmieniany ? Number(this.props.zmienianyPobyt.ilosc_miejsc) : dajIloscOsob(this.props.basket[0].id))
                            .map((o: number) => ({ value: o, text: o })),
                        value: this.state.persons,
                        onChange: this.zmienIloscOsob,
                        disabled: this.disabledAll,
                    },
                },
            },
            {
                block:
                {
                    type: FieldTypes.select,
                    props: {
                        key: t(FormularzLabels.Pokoje),
                        label: t(this.czyUsluga() ? "Usługi" : FormularzLabels.Pokoje) + '',
                        labelSecondary: true,
                        formControlStyle:{ marginBottom: "30px" },
                        className: `${classes.backgroundWhite} ${classes.textSecondary}`,
                        data: this.opcjeMenu(this.props.czyPobytZmieniany ? 1 : Math.min(this.state.freeRooms, Number(CONFIG.hotelMaxIloscPokoi)) )
                            .map((o: number) => ({ value: o, text: o })),
                        value: this.state.rooms,
                        onChange: this.zmienIloscPokoi,
                        disabled: this.disabledAll,
                    } as MuiSelectProps,
                },
            },
            {
                block:
                {
                    type: FieldTypes.text,
                    props: {
                        key: String(t(FormularzLabels.DoZaplaty)),
                        formControlStyle: {
                            display: 'inline-block', paddingBottom: "0px", marginBottom: "24px",
                            width: this.state.width <= mobileBreakpoint
                                ? PoleDlugosciDwaWWierszu.LEWE.value.formControl.mobile : PoleDlugosciDwaWWierszu.LEWE.value.formControl.PC,
                        },
                        label: t(FormularzLabels.DoZaplaty) + '',
                        labelStyle: {
                            width: this.state.width <= mobileBreakpoint
                                ? PoleDlugosciDwaWWierszu.LEWE.value.label.mobile : PoleDlugosciDwaWWierszu.LEWE.value.label.PC,
                        },
                        labelSecondary: true,
                        labelBold: true,
                        style: { width: this.state.width <= mobileBreakpoint ?  PoleDlugosciDwaWWierszu.LEWE.value.field.mobile : PoleDlugosciDwaWWierszu.LEWE.value.field.PC, },
                        inputClasses: `${classes.floatLeft} ${classes.textAlignLeft} ${classes.fontWeightNormal} ${classes.textSecondary}`,
                        value: sumString + ",00 zł",
                        disabled: true,
                    },
                },
            }
        ];
    }

    closeError = () => {
        this.setState({ ...this.state, openError: false });
    }

    czyUsluga = () => {
    let rodz = this.props.basket[0].rodzPokoi.toString()
    return (CONFIG.grafikUslugaRodzPok1 == rodz || CONFIG.grafikUslugaRodzPok2 == rodz || CONFIG.grafikUslugaRodzPok3 == rodz
            || CONFIG.grafikUslugaRodzPok4 == rodz || CONFIG.grafikUslugaRodzPok5 == rodz || CONFIG.grafikUslugaRodzPok6 == rodz
            || CONFIG.grafikUslugaRodzPok7 == rodz || CONFIG.grafikUslugaRodzPok8 == rodz || CONFIG.grafikUslugaRodzPok9 == rodz)
    }

    //PM 2021-11-16
    //wstrzykniecie tylko uzywanych pol z magazynu danych
    //pokoj={CONFIG.grafikiRodzaj === "1" ? this.props.basket[0].rodzPokoi : String(this.props.roomNumber)}
    render = () => {
        const { t, classes } = this.props;

        console.log(this.props)
        console.log("nowy")
        console.log(this.props.basket[0].rodzPokoi.toString())

        let cenaZero = Number(this.roomPrice(0)) === 0

        return (

            <Card>
            <CardContent>
                <Paper>
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={setLocale(this.props.lang)}>
                        <Dialog PaperProps={{ className: classes.dialogPaper }}
                            fullWidth
                            open={this.state.open}
                        >
                            <DialogContent style={{padding: "0"}}
                                   
                                   >
   
                            <Grid container spacing={0}   className={classes.dialogContent}
                                                                style={{ paddingTop: '8px' }} >
                            

                            {this.state.part === 0 ?
                                        <>
                            <Grid
                            className={` ${classes.spanOuterLeft}`} style={{ paddingLeft: this.state.width > 600 ? "12px" : "0"}}
                                        item
                                        xs={12}
                                        md={12}
                                        >
                            
             
                                    <div className={classes.form} style={{minHeight: "492px" }}>
                                        <DialogTitle disableTypography style={{ padding: "0" }}>

                                            <Box style={{ display: "grid" }}>
                                                <Box className={classes.header}>
                                                    <Typography variant="h6" component="h2" color="primary">
                                                        <b>
                                                            <Button onClick={() => this.setState({ leftPanel: 0 })} variant="text" size="small" color="primary" disableTouchRipple
                                                                style={{ marginRight: "10px" }} className={classes.menuButton}
                                                            >
                                                                <b>{t(this.czyUsluga() && CONFIG.grafikUslugaOpisAktywny === "1" ? CONFIG.grafikUslugaOpisOpis : this.czyUsluga() ? "Usługa" : "Booking")}</b>
                                                            </Button>

                                                            {this.props.page.serwerWersja > 100 ? 
                                                                    <Button onClick={() => this.setState({ leftPanel: 1 })} variant="text" size="small" color="primary" disableTouchRipple
                                                                        style={{  }} className={classes.menuButton}
                                                                    >
                                                                        <b> {t("Prices")}</b>
                                                                    </Button> 
                                                                : null} 
                                                                
                                                            
                                                            <Button onClick={() => this.setState({ leftPanel: 2 })} variant="text" size="small" color="primary" disableTouchRipple
                                                                style={{ }} className={classes.menuButton}
                                                            >
                                                                <b> {t("Remarks2")}</b>
                                                            </Button>
                                                            <Button onClick={() => this.setState({ leftPanel: 3 })} variant="text" size="small" color="primary" disableTouchRipple
                                                                    style={{ }} className={classes.menuButton}
                                                                >
                                                                    <b> {t("Invoice data")}</b>
                                                            </Button>
                                                            {/* <span onClick={ () => this.setState({leftPanel: 0})} style={{cursor: "pointer", paddingRight: "10px"}}>{capitalizeFirstLetter(t("Booking"))}</span>
                                        <span onClick={ () => this.setState({leftPanel: 1})} style={{cursor: "pointer"}}>{capitalizeFirstLetter(t("Remarks2"))}</span> */}
                                                        </b>
                                                    </Typography>

                                                    {this.props.page.serwerWersja > 100   ?

                                                    <div className={this.state.leftPanel == 0 ? `${classes.bar} ${classes.active1}`
                                                    : this.state.leftPanel == 1 ? `${classes.bar} ${classes.active2}`
                                                        : this.state.leftPanel == 2 ? `${classes.bar} ${classes.active3}`
                                                            : this.state.leftPanel == 3 ? `${classes.bar} ${classes.active4}`
                                                                : `${classes.bar} ${classes.active5}`}></div> 
                                                                :

                                                                <div className={this.state.leftPanel == 0 ? `${classes.bar} ${classes.active1}`
                                                                : this.state.leftPanel == 2 ? `${classes.bar} ${classes.active2}`
                                                                    : this.state.leftPanel == 3 ? `${classes.bar} ${classes.active3}`
                                                                        : `${classes.bar} ${classes.active4}`}></div>}
                                                </Box>

                                            </Box>

                                        </DialogTitle>


                                        {this.state.leftPanel === 0 ? renderFields(this.leftFields()) :
                                                  this.state.leftPanel === 1 && this.state.dostepnosc.length > 0 ?
                                                  <Ceny width={this.state.width} dostepnosc={this.state.dostepnosc} fromDate={this.state.fromDate}/> :
                                                  this.state.leftPanel === 2 ?
                                                      <UserPrefs
                                                          width={this.state.width}
                                                          panel={this.state.leftPanel}
                                                          onChangeRemarks={this.onChangeRemarks}
                                                          remarks={this.state.remarks}
                                                          checked={this.state.checked}
                                                          changeChecked={this.changeChecked}
                                                      /> :
                                                      this.state.leftPanel === 3 ?
                                                          <FormularzFaktura
                                                              checked={this.state.checked}
                                                              changeChecked={this.changeChecked}
                                                          /> : null}

                                            <DialogActions style={{  position: "absolute", bottom: "8px", right: "12px" }}>
                                                    <Button variant="outlined" color="primary" size="small"
                                                        //className={classes.actionButtons}
                                                        onClick={this.state.leftPanel === 0 ? this.handleCloseWithoutModal : () => this.setState({ leftPanel: 0 }) }
                                                        >
                                                        <b><Trans>{this.state.leftPanel === 0 ? "back graphic" : "back residence"}</Trans></b>
                                                    </Button>
                                                    <Button variant="contained" color="primary" size="small"
                                                        //className={classes.actionButtons}
                                                        //disabled={isSubmitting || !this.state.rightFieldsRender}
                                                        disabled={cenaZero}
                                                        onClick={() => this.setPart(1)}

                                                        //style={{ marginRight: this.props.width <= mobileBreakpoint ? "0" : "0px" }}
                                                    >
                                                        <b><Trans>{"next person"}</Trans></b>
                                                        {/* <b><Trans>{this.props.czyPobytZmieniany ? "Save" : "Reserve"}</Trans></b> */}
                                                    </Button>
                                                </DialogActions>

                                    </div>
                                    </Grid>

                                    </> : this.state.part === 1 ?
                                        <>

            <UserInfo
                open={this.state.open}
                openInfo={this.state.openInfo}
                infoValues={this.state.infoValues}
                reservation={this.state.reservation}
                fromDate={this.state.fromDate}
                toDate={this.state.toDate}
                fromDatePrev={this.state.fromDatePrev}
                toDatePrev={this.state.toDatePrev}
                fromDateError={this.state.fromDateError}
                toDateError={this.state.toDateError}
                openError={this.state.openError}
                persons={this.state.persons}
                width={this.state.width}
                roomPrice={this.roomPrice}
                closeDialogInfo={this.closeDialogInfo}
                handleSend={this.handleSend}
                handleCloseWithoutModal={this.handleCloseWithoutModal}
                leftFields={this.leftFields}
                closeError={this.closeError}
                submitDialogInfo={this.submitDialogInfo}
                pokojOpis={this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.rodz_pokoi_opis : this.props.basket[0].opis}
                pokoj={CONFIG.grafikiRodzaj === "1" ? this.props.basket[0].rodzPokoi : String(this.props.roomNumber)}
                rodz_pokoi={this.props.basket[0].rodz_pokoi.toString()}
                setPart={this.setPart}
            />
            </> : null}

            <MuiThemeProvider theme={ selectTheme("5") }>                                
            <Dialog
                disableEscapeKeyDown
                maxWidth="xs"
                open={this.state.openError}
                fullWidth
            >
                <DialogTitle disableTypography>
                    <Typography gutterBottom variant="h5" component="h2" color="error" style={{ fontSize: "1.25rem" }}>
                        <b><Trans>Warning</Trans></b>
                    </Typography>
                    <hr />
                </DialogTitle>
                <DialogContent>
                    <DialogContentText gutterBottom variant="h5" component="h2" className={classes.text}>
                        <Trans>In time</Trans>:
                    </DialogContentText>
                    <DialogContentText gutterBottom variant="h5" component="h2" className={classes.text}>
                        {'  * '}<span style={{ textTransform: "lowercase" }}><Trans>Check-in</Trans></span>{':'} <Typography component="span" color={"error"}><b>{this.state.fromDateError}</b></Typography>
                    </DialogContentText>
                    <DialogContentText gutterBottom variant="h5" component="h2" className={classes.text}>
                        {'  * '}<span style={{ textTransform: "lowercase" }}><Trans>Check-out</Trans></span>{':'} <Typography component="span" color={"error"}><b>{this.state.toDateError}</b></Typography>
                    </DialogContentText>
                    <DialogContentText gutterBottom variant="h5" component="h2" className={classes.text}>
                        {'  * '}<Trans>No rooms</Trans>{':'} <Typography component="span" color={"error"}><b>{this.props.czyPobytZmieniany ? this.props.zmienianyPobyt.rodz_pokoi_opis : this.props.basket[0].opis}</b></Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                <MuiThemeProvider theme={ThemeOrange}>
                    <Button onClick={() => this.closeError()} variant="contained" size="small" color="primary"
                        style={{ textTransform: "none", fontSize: "0.8rem" }}
                    >
                        <b><Trans>OK</Trans></b>
                    </Button>
                    </MuiThemeProvider>
                </DialogActions>
            </Dialog>
            </MuiThemeProvider>

            </Grid>

                                </DialogContent>
                            </Dialog>
                        </MuiPickersUtilsProvider>

                    </Paper>
                </CardContent>
            </Card>
        );

    }
}

const styles = (theme: Theme) => ({
    textAlignLeft: {
        textAlign: "left" as "left",
    },
    fontWeightNormal: {
        //fontWeight: "normal" as "normal"
        fontWeight: "bold" as "bold"
    },
    textSecondary: {
        //color: theme.palette.text.secondary
        color: theme.palette.primary.main
    },
    floatLeft: {
        float: "left" as "left"
    },
    textAlignCenter: {
        textAlign: "center" as "center",
    },
    backgroundWhite: {
        backgroundColor: "#ffffff"
    },

    menuButton: {
        width: "70px",
        //textTransform: "none" as "none", 
        //fontSize: "1rem", 
        padding: "4px 5px", 
        lineHeight: "1.5" ,
        fontSize: "11px",
        textTransform: "uppercase" as "uppercase", 
        color: "rgb(182, 59, 77)"
        //"&:hover": {
        //     color: theme.palette.text.main,
        //    //color: "rgb(230, 81, 0)",
        //  }
    },
    header: {
        position: "relative" as "relative",
        borderBottom: "1px solid #e0e0e0"
      },
      headerRight: {
          float: "right" as "right",
          [theme.breakpoints.down('sm')]: {
            display: "contents"
          }
      },
      link: {
        [theme.breakpoints.down('xs')]: {
          padding: "15px 0px",
          textAlign: "center",
          width: "25%"
        }
      },
      active: {
        fontWeight: 700,
        //fontSize: "0.85rem"
        "&:hover": {
          color: theme.palette.primary.main,
        }
      },
      bar: {
    
        [theme.breakpoints.up('xs')]: {
          backgroundColor: "rgb(230, 81, 0)",
          //width: "120px",
          width: "70px",
          height: "1px",
          left: 0,
          position: "absolute",
          transition: "left .2s ease",
              webkitTransition: "left .2s ease",
        },
        [theme.breakpoints.down('xs')]: {
          backgroundColor: 'rgb(230, 81, 0)',
         // width: "25%",
          width: "70px",
          height: "1px",
          left: 0,
          position: "absolute",
          transition: "left .2s ease",
              webkitTransition: "left .2s ease",
        }
    
      },
      active1: {
        left: "0px",
      },
      active2: {
          left: "70px"
        // left: "12%",
        // [theme.breakpoints.down('md')]: {
        //     //left: "25%",
        //     left: "9%",
        //   },
        // [theme.breakpoints.down('xs')]: {
        //   //left: "25%",
        //   left: "19%",
        // }
      },
      active3: {
        left: "140px",
        //width: "64px"
        //[theme.breakpoints.down('xs')]: {
        //  left: "50%",
        //}
      },
      active4: {
        left: "210px",
        // [theme.breakpoints.down('xs')]: {
        //   left: "75%",
        // }
      }, 
      active5: {
        left: "86%",
        [theme.breakpoints.down('xs')]: {
          left: "75%",
        }
      }, 
      dialogContent: {
        //maxWidth: "1141px",
       // minWidth: "368px",
        paddingLeft: "12px",
        paddingRight: "12px",
        paddingBottom: "8px",
        //minHeight: "382px",
        minHeight: "400px",
      },
      spanOuter: {
        maxWidth: "552px",
        minWidth: "350px",
        minHeight: "366px",
        width: "100%"
      },
      spanOuterLeft: {
        backgroundColor: "#f9f9f9",
      },
      legend: {
        padding: "35px 8px 35px 0px"
      },
      dialogPaper: {
        maxHeight: "100%",
        //maxWidth: "1177px",
        minWidth: "350px",
      },
      form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
      },
      text: {
        fontSize: "1.07rem",
        whiteSpace: "break-spaces" as "break-spaces",
      },
      primary: {
        color: theme.palette.primary.main
      },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
    czyPobytZmieniany: state.pageState.czyPobytZmieniany,
    zmienianyPobyt: state.pageState.zmienianyPobyt,
    dateFromFormularz: state.pageState.dateFromFormularz,
    dateTo: state.pageState.dateTo,
    basket: state.pageState.basket,
    openOptions: state.pageState.openOptions,
    lang: state.pageState.lang,
    roomNumber: state.pageState.roomNumber,
    optionsValues: state.pageState.optionsValues,
    contact: state.pageState.contact,
    theme: state.pageState.theme,
    zapisanyFormularz: state.pageState.zapisanyFormularz,
    preautoryzacja: state.pageState.preautoryzacja,
    initialValues: state.pageState.initialValues,
    options: state.pageState.options,
    daneNIP: state.pageState.daneNIP,
});

export default
    withStyles(styles)(connect(mapStateToProps)(withTranslation()(FormularzImplementacja)));
